import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=e2aa5fa4&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=js"
export * from "./Rankings.vue?vue&type=script&lang=js"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=e2aa5fa4&prod&scoped=true&lang=css"
import style1 from "./Rankings.vue?vue&type=style&index=1&id=e2aa5fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2aa5fa4",
  null
  
)

export default component.exports